
<dialog-close-button></dialog-close-button>

<h1>{{ data.label | translate }}</h1>

<mat-dialog-content>
  <div [class]="data.type" [innerHTML]="data.display | storyTextDisplay | safeHtml"></div>
</mat-dialog-content>
